<div class="apply-job-container">
  <div mat-dialog-title>
    <h2>Apply for this position</h2>
    <p class="font-20 margin-top-10 margin-bottom-10">
      Please fill the details below and we will get in touch with you
    </p>
  </div>
  <div mat-dialog-content>
    <form
      name="form"
      (ngSubmit)="f.form.valid && processData()"
      #f="ngForm"
      novalidate
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group padding-right-10 margin-bottom-mobile-0">
            <!-- APPLY JOB: NAME -->
            <div class="form-field" mat-form-field>
              <mat-label>Name</mat-label>
              <input class="input-field"
                matInput
                type="text"
                [(ngModel)]="applyJobData.name"
                name="jobname"
                #jobname="ngModel"
                minlength="1"
                maxlength="32"
                (keypress)="keyPressAlpha($event)"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group margin-bottom-mobile-0">
            <!-- APPLY JOB:  POSITION APPLIED FOR -->
            <div class="form-field" mat-form-field>
              <mat-label>Position Applied for</mat-label>
              <input class="input-field"
                matInput
                type="text"
                [(ngModel)]="applyJobData.positionApplied"
                name="positionapplied"
                #positionapplied="ngModel"
                (keypress)="keyPressAlpha($event)"
                required
              />
              
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group padding-right-10 margin-bottom-mobile-0">
            <!-- APPLY JOB : MOBLIE NUMBER -->
            <div class="form-field" mat-form-field>
              <mat-label>Mobile</mat-label>
              <input class="input-field"
                matInput
                type="text"
                [(ngModel)]="applyJobData.mobileNumber"
                name="mobile"
                #mobile="ngModel"
                minlength="10"
                maxlength="10"
                [pattern]="mobNumberPattern"
                required
              />
              <div mat-error *ngIf="mobile.hasError('pattern')">Mobile number not valid.</div>
              </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group margin-bottom-mobile-0">
            <!-- APPLY JOB:  EMAIL ID -->
            <div class="form-field" mat-form-field>
              <mat-label>Email</mat-label>
              <input class="input-field"
                matInput
                type="text"
                [(ngModel)]="applyJobData.emailId"
                name="email"
                #email="ngModel"
                [pattern]="emailPattern"
                required
                minlength="1"
                maxlength="64"
              />
              <div mat-error *ngIf="email.hasError('pattern')"
                >Please Enter valid Email.</div>
            </div>
          </div>
        </div>
      </div>
      <!-- APPLY JOB: MESSAGE -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group margin-bottom-mobile-0">
            <div class="form-field" mat-form-field>
              <mat-label>Message (Max. 100 Characters)</mat-label>
              <textarea class="input-field"
                matInput
                maxlength="100"
                [(ngModel)]="applyJobData.message"
                name="message"
                #message="ngModel"
                required
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- APPLY JOB: UPLOAD RESUME -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group margin-bottom-mobile-0">
              <app-file-input
                (fileChange)="onFileChange($event)"
                placeholder="Upload Resume"
                [(ngModel)]="fileName"
                name="fileInput"
                [required] = "true"
              >
                <div mat-raised-button color="primary" class="mat-button-medium">
                  Choose
                </div>
              </app-file-input>
          </div>
        </div>
      </div>
      <!-- CAREER:JOB SUBMIT -->
      <div class="margin-top-20">
        <button
          mat-raised-button
          color="primary"
          class="mat-button-large"
          type="submit"
          [disabled]="!f.valid"
        >
          Submit
        </button>
        <button
          mat-button
          color="primary"
          class="mat-button-large margin-left-25"
          mat-dialog-close
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
